import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
    pageTitle: {
        margin: '0 1.5%',
        fontSize: '32px',
        marginTop: '45px'
    }
})

const CoursesError = ({ refresh }) => {
    const classes = useStyles()

    return (
        <>
            <Typography gutterBottom variant="h5" component="h2" className={classes.pageTitle} color={'primary'}>Algo deu errado!</Typography>
            <Button variant="contained" color="primary" style={{ margin: '32px 1.5%' }} onClick={() => refresh()}>Tentar novamente</Button>
        </>
    )
}

export default CoursesError;